import { motion } from "framer-motion";
import { HERO_IMAGES } from "@/data/siteData";

export default function BeforeAfter() {
  return (
    <section data-testid="before-after-section" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-14">
          <div className="text-sm uppercase tracking-[0.25em] text-[#066ec4] font-bold mb-4">
            Avant / Après
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-[#00367e] leading-[1.1]">
            La <span className="dh-underline">différence</span> est immédiate
          </h2>
          <p className="mt-5 text-lg text-slate-700">
            Photos réelles de nos interventions. Hottes professionnelles, gaines d'extraction et cuisines retrouvent leur état d'origine grâce à notre dégraissage haute pression.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative rounded-3xl overflow-hidden shadow-[0_24px_60px_rgba(0,54,126,0.16)] border border-slate-100"
        >
          <img
            src={HERO_IMAGES.beforeAfter}
            alt="Hotte de restaurant avant et après dégraissage professionnel"
            loading="lazy"
            width="1600" height="900"
            className="w-full object-cover"
          />
          <div className="absolute top-5 left-5 px-4 py-2 rounded-full bg-black/70 backdrop-blur text-white text-sm font-bold uppercase tracking-widest">Avant</div>
          <div className="absolute top-5 right-5 px-4 py-2 rounded-full bg-[#00367e] text-white text-sm font-bold uppercase tracking-widest">Après</div>
        </motion.div>

        <div className="grid sm:grid-cols-3 gap-5 mt-10">
          <Card num="+95%" label="Graisse éliminée à chaque passage" />
          <Card num="100%" label="Conformité arrêté du 25/06/1980" />
          <Card num="3 mois" label="Garantie sur intervention" />
        </div>
      </div>
    </section>
  );
}

const Card = ({ num, label }) => (
  <div className="bg-white rounded-2xl p-7 border border-slate-100 shadow-[0_8px_30px_rgb(0,54,126,0.06)]">
    <div className="dh-num text-5xl text-[#00367e] mb-2">{num}</div>
    <div className="text-slate-700 font-medium">{label}</div>
  </div>
);
